module.exports = __webpack_public_path__ + "img/nav2.ee22f859.png";